import React, { PureComponent } from 'react'
import * as R from 'ramda'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import HoverInfo from '../../UniformComponents/HoverInfo'

import Button from '../../UniformComponents/Button'
import './styles/date.scss'
import Input from './Input'

class Date extends PureComponent {
    constructor(props) {
        super(props)

        if (typeof props.register === 'function') {
            props.register(props.name, this.validate, props.path)
        }
        const { value: selectedDate, dateFormat } = this.props
        const lastValidDate = selectedDate && moment(selectedDate).isValid()
            ? moment(selectedDate).format(dateFormat ?? 'DD/MM/YYYY')
            : ''

        this.toggleTimer = null
        this.state = {
            isInValid: false,
            isOpen: false,
            manualInput: lastValidDate,
            isTyping: false,
            lastValidDate: undefined,
        }
    }

    componentDidUpdate(prevProps) {
        // input value is sometimes not present in first render
        const { value, dateFormat } = this.props
        const { lastValidDate } = this.state
        if (prevProps.value !== value) {
            const formattedDate = value && moment(value).isValid()
                ? moment(value).format(dateFormat ?? 'DD/MM/YYYY')
                : lastValidDate
            this.setState({
                lastValidDate: formattedDate,
                manualInput: formattedDate,
            })
        }
    }

    componentWillUnmount() {
        const { unregister, name, path } = this.props

        if (typeof unregister === 'function') {
            unregister(name, path)
        }
    }

    validate = ({ value, name }, setState = false) => {
        const { isMandatory, validate } = this.props

        const hasValue = R.and(!R.isNil(value), !R.isEmpty(value))
        let isValid = !isMandatory || hasValue
        if (typeof validate === 'function') {
            isValid = isValid && validate({ value, name })
        }

        if (setState) {
            this.setState({
                isInValid: !isValid,
            })
        }

        return isValid
    }

    onBlur = (date) => {
        const { name, onBlur, dateFormat, dontValidateOnBlur } = this.props
        const { isInValid } = this.state
        const value = date
        const textFormat = moment(date).format(dateFormat ?? 'DD/MM/YYYY')
        this.setState({ manualInput: textFormat })
        if (!dontValidateOnBlur || isInValid) {
            this.validate({ value, name }, true)
        }

        if (typeof onBlur === 'function') {
            onBlur({ value, name, textFormat })
        }
    }

    handleChange = (date) => {
        this.setState({ isOpen: false })
        this.onBlur(date)
    }

    togglePicker = () => {
        clearTimeout(this.toggleTimer)
        this.toggleTimer = setTimeout(() => {
            this.setState((prevState) => ({ isOpen: !prevState.isOpen }))
        }, 300)
    }

    handleInputChange = (e) => {
        const { showTimeSelect } = this.props
        const containsLetters = /[a-zA-Z]/.test(e.value)
        if (containsLetters && !showTimeSelect) return
        this.setState({
            manualInput: e.value,
            isTyping: true,
        })
    }

    handleInputBlur = (obj) => {
        const {
            name,
            onBlur,
            dateFormat,
            minDate,
            maxDate,
        } = this.props
        const { lastValidDate } = this.state
        const typedValue = obj.value

        if (!typedValue) {
            if (lastValidDate) {
                this.setState({
                    manualInput: lastValidDate,
                    isTyping: false,
                })
                const lastValidMoment = moment(lastValidDate, dateFormat ?? 'DD/MM/YYYY')
                if (typeof onBlur === 'function' && lastValidMoment.isValid()) {
                    onBlur({ value: lastValidMoment, name })
                }
                return // empty input, reverting to last valid date
            }
            return // empty input on new form (no last valid date)
        }

        const typedDate = moment(typedValue, dateFormat ?? 'DD/MM/YYYY')
        const isAfterMinDate = minDate ? typedDate.isSameOrAfter(minDate) : true
        const isBeforeMaxDate = maxDate ? typedDate.isSameOrBefore(maxDate) : true
        const isInRange = isAfterMinDate && isBeforeMaxDate
        if (typedDate.isValid() && isInRange) {
            const formatted = typedDate.format(dateFormat ?? 'DD/MM/YYYY')
            this.setState({
                lastValidDate: formatted,
                manualInput: formatted,
                isTyping: false,
            })
            if (typeof onBlur === 'function') onBlur({ value: typedDate, name, textFormat: formatted })
        } else if (lastValidDate) { // invalid date input, reverting to last valid date
            this.setState({ manualInput: lastValidDate, isTyping: false })
        } else { // invalid date input, reverting to empty value
            this.setState({ manualInput: '', isTyping: false })
        }
    }

    getInputValue = (selectedDate) => {
        const { dateFormat } = this.props
        const { manualInput, isTyping } = this.state
        if (isTyping || !selectedDate) {
            return manualInput
        }
        return moment(selectedDate).isValid()
            ? moment(selectedDate).format(dateFormat ?? 'DD/MM/YYYY')
            : manualInput
    }

    getDisplayTime = (selectedDate) => {
        const { placeholder, dateFormat, useGMT = true } = this.props
        if (selectedDate) {
            if (useGMT) return moment(selectedDate).tz('GMT').format(`${dateFormat} ([GMT])`)
            return moment(selectedDate).format(dateFormat)
        }
        return placeholder
    }

      renderManualInput = (selectedDate) => {
          const {
              dateFormat, name, allowManualDateEdit, placeholder, disabled,
          } = this.props

          const inputValue = this.getInputValue(selectedDate)

          return (
              <>
                  {allowManualDateEdit ? (
                      <Input
                          type="text"
                          value={inputValue}
                          placeholder={placeholder}
                          onChange={this.handleInputChange}
                          onBlur={this.handleInputBlur}
                          blurOnEnter
                          name={name}
                          cssClass="date-editable-field"
                          disabled={disabled}
                      />
                  ) : (
                      <p className={`${selectedDate ? '' : 'placeholder'}`}>
                          {selectedDate ? moment(selectedDate).format(dateFormat ?? 'DD/MM/YYYY') : placeholder}
                      </p>
                  )}
                  {!disabled
                    && (
                        <i
                            className="date-icon fa-light fa-calendar"
                            onClick={allowManualDateEdit ? this.togglePicker : null}
                            aria-hidden
                        />
                    )}
              </>
          )
      }

      render() {
          const {
              value, className, minDate, maxDate, disabled,
              emptyError, label, calendarCss,
              tooltipTitle, tooltipText, tooltipLinkLabel, tooltipLink,
              showTimeSelect, showTimeSelectOnly, dateFormat, allowManualDateEdit,
          } = this.props
          const {
              isOpen, isInValid,
          } = this.state

          const selectedDate = value ?? null

          const errorClass = isInValid ? 'date-error' : ''

          return (
              <div id="form-date">
                  <Button cssClass={`${className} ${errorClass} date-btn`} onClick={!allowManualDateEdit && !disabled ? this.togglePicker : null}>
                      <label className={`date-label ${!allowManualDateEdit ? 'button-date-label' : ''}`}>
                          {label}
                          {tooltipText && (
                              <HoverInfo
                                  cssClass="hover-info"
                                  title={tooltipTitle}
                                  desc={tooltipText}
                                  linkText={tooltipLinkLabel}
                                  href={tooltipLink}
                                  dir="right"
                              >
                                  <i className="info-icon fa-solid fa-circle-question" />
                              </HoverInfo>
                          )}
                      </label>
                      <div className={`date-field ${disabled ? 'disabled-date' : ''}`}>
                          {showTimeSelectOnly ? (
                              <>
                                  <p className={`${selectedDate ? '' : 'placeholder'} ${disabled ? 'disabled-time' : ''}`}>
                                      {this.getDisplayTime(selectedDate)}
                                  </p>
                                  {!disabled && <i className="date-icon fa-light fa-clock" />}
                              </>
                          ) : (
                              this.renderManualInput(selectedDate)
                          )}
                      </div>
                  </Button>
                  {isOpen ? (
                      <DatePicker
                          calendarClassName={`picker ${calendarCss} ${minDate ? 'min-date-set' : ''}`}
                          selected={selectedDate === null ? selectedDate : moment(selectedDate)}
                          onChange={this.handleChange}
                          onClickOutside={this.togglePicker}
                          minDate={minDate}
                          maxDate={maxDate}
                          inline
                          showTimeSelect={showTimeSelect}
                          showTimeSelectOnly={showTimeSelectOnly}
                          dateFormat={dateFormat}
                          timeFormat="HH:mm"
                      />
                  ) : null}
                  {(emptyError && isInValid) && (
                      <p className="error-msgs">{emptyError}</p>
                  )}
              </div>
          )
      }
}

export default Date
